<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';

  interface Props {
    icon?: string;
    active?: boolean;
    name?: string;
    disabled?: boolean;
    children?: import('svelte').Snippet;
    onclick?: (e: MouseEvent) => void;
  }

  let {
    icon = '',
    active = false,
    name = '',
    disabled = false,
    children,
    onclick
  }: Props = $props();
</script>

<button {disabled} data-cy={name} class="comp-icon-link" class:active {onclick}>
  <div class="icon default">
    <Icon value="{icon} {active ? 'active' : 'grey'}" />
  </div>
  <div class="icon hover">
    <Icon value={icon} />
  </div>
  <div class="label">{@render children?.()}</div>
</button>

<style>
  .comp-icon-link,
  .comp-icon-link .icon {
    display: flex;
    align-items: center;
  }

  .comp-icon-link {
    color: var(--grey-medium);
  }

  .comp-icon-link:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  .comp-icon-link:hover {
    color: var(--grey-dark);
  }

  .comp-icon-link.active {
    color: var(--blue);
  }

  .comp-icon-link .icon {
    margin-right: 12px;
    margin-top: 2px;
  }
  .comp-icon-link .icon.hover {
    display: none;
  }

  .comp-icon-link:not(.active):hover .icon.hover {
    display: flex;
  }
  .comp-icon-link:not(.active):hover .icon.default {
    display: none;
  }
</style>
